import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import { withNavItem } from './withNavItem';

class NavItemPlay extends Component {
  constructor() {
    super();
    this.rendered = false;
  }
  componentDidMount() {
    this.rendered = true;
  }
  render() {
    // console.log('render play');
    this.props.isActiveLinkFunc(this.props.location.pathname === '/');
    return (

      <NavLink onClick={e => this.props.handleClick(e)} className={`nav-link nav-link--play ${this.props.imagesLoadedClass}`} activeClassName="nav-link--active" exact to="/">
        <span ref={el => this.props.navLinkFunc(el, this.rendered)} onMouseMove={e => this.props.mousemoveFn(e)} onMouseEnter={e => this.props.mouseenterFn(e)} onMouseLeave={e => this.props.mouseleaveFn(e)} className={`${this.props.wobbling} nav-link__inner`}>
          <span className="nav-link__letter-holder letter-p">
            <span className="nav-link__letter">P</span>
            <span className="letter-strokes letter-strokes--p">
              <span className="p-left-stroke letter-stroke" style={{ transform: this.props.groupB }}>
                <svg className="letter-stroke__svg" viewBox="0 0 109 305">
                  <mask id="p-left-stroke-mask">
                    <path ref={el => this.props.activePaths(el, this.rendered)} className="letter-stroke__svg-path" d="M59,0c0,0,0.1,114-0.5,195.8S58,314.5,58,314.5" />
                  </mask>
                  <image ref={image => this.props.svgImages(image, this.rendered)} mask="url(#p-left-stroke-mask)" className="letter-stroke__svg-image" xlinkHref="/img/p-left-stroke@2x.jpg" width="109" height="305" />
                </svg>
              </span>
              <span className="p-top-stroke letter-stroke" style={{ transform: this.props.groupD }}>
                <svg className="letter-stroke__svg" viewBox="0 0 200 228">
                  <mask id="p-top-stroke-mask" width="209.6px" height="229.6px">
                    <path ref={el => this.props.activePaths(el, this.rendered)} className="letter-stroke__svg-path" d="M0,58.1c45,0,69.6-1.9,106,1c25,2,48.2,25.7,46,58c-1,15-14.2,39.6-35,48c-31.1,12.5-69,5-107,2" />
                  </mask>
                  <image ref={image => this.props.svgImages(image, this.rendered)} mask="url(#p-top-stroke-mask)" className="letter-stroke__svg-image" xlinkHref="/img/p-top-stroke@2x.jpg" width="200" height="228" />
                </svg>
              </span>
            </span>
          </span>

          <span className="nav-link__letter-holder letter-l">
            <span className="nav-link__letter">L</span>
            <span className="letter-strokes letter-strokes--l">
              <span className="l-left-stroke letter-stroke" style={{ transform: this.props.groupC }}>
                <svg className="letter-stroke__svg" viewBox="0 0 107 304">
                  <mask id="l-left-stroke-mask">
                    <path ref={el => this.props.activePaths(el, this.rendered)} className="letter-stroke__svg-path" d="M59,0c0,0,0.1,114-0.5,195.8S58,314.5,58,314.5" />
                  </mask>
                  <image ref={image => this.props.svgImages(image, this.rendered)} mask="url(#l-left-stroke-mask)" className="letter-stroke__svg-image" xlinkHref="/img/l-left-stroke@2x.jpg" width="107" height="304" />
                </svg>
              </span>
              <span className="l-bottom-stroke letter-stroke" style={{ transform: this.props.groupB }}>
                <svg className="letter-stroke__svg" viewBox="0 0 152 107">
                  <mask id="l-bottom-stroke-mask">
                    <path ref={el => this.props.activePaths(el, this.rendered)} className="letter-stroke__svg-path" d="M0.1,58c0,0,39.5-0.1,72.8,0.5s84.2,0.5,84.2,0.5" />
                  </mask>
                  <image ref={image => this.props.svgImages(image, this.rendered)} mask="url(#l-bottom-stroke-mask)" className="letter-stroke__svg-image" xlinkHref="/img/l-bottom-stroke@2x.jpg" width="152" height="107" />
                </svg>

              </span>
            </span>
          </span>

          <span className="nav-link__letter-holder letter-a">
            <span className="nav-link__letter">A</span>
            <span className="letter-strokes letter-strokes--a">
              <span className="a-left-stroke letter-stroke" style={{ transform: this.props.groupA }}>
                <svg className="letter-stroke__svg" viewBox="0 0 202 302">
                  <mask id="a-left-stroke-mask">
                    <path ref={el => this.props.activePaths(el, this.rendered)} className="letter-stroke__svg-path" d="M152,0c0,42-11,49-47,146S58,268,58,304" />
                  </mask>
                  <image ref={image => this.props.svgImages(image, this.rendered)} mask="url(#a-left-stroke-mask)" className="letter-stroke__svg-image" xlinkHref="/img/a-left-stroke@2x.jpg" width="202" height="302" />
                </svg>
              </span>
              <span className="a-right-stroke letter-stroke" style={{ transform: this.props.groupC }}>
                <svg className="letter-stroke__svg" viewBox="0 0 202 299">
                  <mask id="a-right-stroke-mask">
                    <path ref={el => this.props.activePaths(el, this.rendered)} className="letter-stroke__svg-path" d="M58,0c0,42,11,49,47,146s47,122,47,158" />
                  </mask>
                  <image ref={image => this.props.svgImages(image, this.rendered)} mask="url(#a-right-stroke-mask)" className="letter-stroke__svg-image" xlinkHref="/img/a-right-stroke@2x.jpg" width="202" height="299" />
                </svg>
              </span>
              <span className="a-middle-stroke letter-stroke" style={{ transform: this.props.groupD }}>
                <svg className="letter-stroke__svg" viewBox="0 0 127 107">
                  <mask id="a-middle-stroke-mask">
                    <path ref={el => this.props.activePaths(el, this.rendered)} className="letter-stroke__svg-path" d="M0.1,58c0,0,33.5-0.1,66.8,0.5s63.2,0.5,63.2,0.5" />
                  </mask>
                  <image ref={image => this.props.svgImages(image, this.rendered)} mask="url(#a-middle-stroke-mask)" className="letter-stroke__svg-image" xlinkHref="/img/a-middle-stroke@2x.jpg" width="127" height="107" />
                </svg>
              </span>
            </span>
          </span>

          <span className="nav-link__letter-holder letter-y">
            <span className="nav-link__letter">Y</span>
            <span className="letter-strokes letter-strokes--y">
              <span className="y-left-stroke letter-stroke" style={{ transform: this.props.groupD }}>
                <svg className="letter-stroke__svg" viewBox="0 0 196 232">
                  <mask id="y-left-stroke-mask-1">
                    <path ref={el => this.props.activePaths(el, this.rendered)} className="letter-stroke__svg-path" d="M58,0c0,42,13.8,71.5,37,117c24,47,52,80,52,116" />
                  </mask>
                  <image ref={image => this.props.svgImages(image, this.rendered)} mask="url(#y-left-stroke-mask-1)" className="letter-stroke__svg-image" xlinkHref="/img/y-left-stroke@2x.jpg" width="196" height="232" />
                </svg>
              </span>
              <span className="y-right-stroke letter-stroke" style={{ transform: this.props.groupC }}>
                <svg className="letter-stroke__svg" viewBox="0 0 218 215">
                  <mask id="y-right-stroke-mask-1">
                    <path ref={el => this.props.activePaths(el, this.rendered)} className="letter-stroke__svg-path" style={{ strokeWidth: '219' }} d="M110.5,0.1c0,0,0.1,83.6-0.5,143.5c-0.5,60-0.5,90-0.5,90" />
                  </mask>
                  <image ref={image => this.props.svgImages(image, this.rendered)} mask="url(#y-right-stroke-mask-1)" className="letter-stroke__svg-image" xlinkHref="/img/y-right-stroke@2x.jpg" width="218" height="215" />
                </svg>
              </span>
              <span className="y-bottom-stroke letter-stroke" style={{ transform: this.props.groupA }}>
                <svg className="letter-stroke__svg" viewBox="0 0 106 122">
                  <mask id="y-bottom-stroke-mask-1">
                    <path ref={el => this.props.activePaths(el, this.rendered)} className="letter-stroke__svg-path" d="M59,0.1c0,0,0.1,43.5-0.5,76.8S58,125.6,58,125.6" />
                  </mask>
                  <image ref={image => this.props.svgImages(image, this.rendered)} mask="url(#y-bottom-stroke-mask-1)" className="letter-stroke__svg-image" xlinkHref="/img/y-bottom-stroke@2x.jpg" width="106" height="122" />
                </svg>
              </span>
            </span>
          </span>
        </span>
      </NavLink>

    );
  }
}

NavItemPlay.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  activePaths: PropTypes.func.isRequired,
  svgImages: PropTypes.func.isRequired,
  imagesLoadedClass: PropTypes.string.isRequired,
  isActiveLinkFunc: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired,
  navLinkFunc: PropTypes.func.isRequired,
  mousemoveFn: PropTypes.func.isRequired,
  mouseenterFn: PropTypes.func.isRequired,
  mouseleaveFn: PropTypes.func.isRequired,
  wobbling: PropTypes.string.isRequired,
  groupA: PropTypes.string.isRequired,
  groupB: PropTypes.string.isRequired,
  groupC: PropTypes.string.isRequired,
  groupD: PropTypes.string.isRequired,
};

export default withNavItem(NavItemPlay);



// WEBPACK FOOTER //
// ./src/components/NavItemPlay.js